module.exports = __webpack_public_path__ + "02_face.18b602a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/02_face.png
// module id = nLRn
// module chunks = 0